import { Route } from '@angular/router';
import { isAgentGuard } from '@rma/dashboard/authentication/public/util-auth-redirect';
import { experienceVisibilityGuard } from '@rma/dashboard/layout/public/api-experience';

export const settingsRoutes: Route[] = [
  {
    path: 'settings',
    children: [
      {
        path: 'data-feeds',
        loadChildren: () => import('@rma/dashboard/settings/data-feed-management'),
      },
      {
        path: 'easy-reviews',
        loadChildren: () => import('@rma/dashboard/settings/easy-reviews'),
      },
      {
        path: 'email-preferences',
        loadChildren: () => import('@rma/dashboard/settings/email-preferences'),
      },
      {
        path: 'linked-accounts',
        loadChildren: () => import('@rma/dashboard/linked-accounts/settings'),
      },
      {
        path: 'templates',
        loadChildren: () => import('@rma/dashboard/communication/message-templates'),
      },
      {
        path: 'review-links',
        canActivate: [experienceVisibilityGuard((s) => s.showReviewLinks$)],
        loadChildren: () => import('@rma/dashboard/settings/review-links'),
      },
      {
        path: 'assistants',
        loadChildren: () => import('@rma/dashboard/assistant-access/access-approval'),
        canActivate: [isAgentGuard('/manage-account/assistant-access')],
      },
      {
        path: 'brand-kits',
        loadChildren: () => import('@rma/dashboard/settings/brand-kits'),
      },
    ],
  },
];
